import React from 'react'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import moment from 'moment'
import Datetime from 'react-datetime'
import { Line, Pie } from 'react-chartjs-2'
import _orderBy from 'lodash/orderBy'

import { lineChartDataset, pieChartDataset } from 'variables/chartSettings'

import statsAgentiTable from 'graphql/queries/statsAgentiTable'
import statsAgentiPieCharts from 'graphql/queries/statsAgentiPieCharts'
import statsAgentiLineChartAndamentoAnnuale from 'graphql/queries/statsAgentiLineChartAndamentoAnnuale'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'

// material-ui icons
import Group from 'material-ui-icons/Group'
import Timeline from 'material-ui-icons/Timeline'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import IconCard from 'components/Cards/IconCard.jsx'

import Table from 'material-ui/Table'
import TableHead from 'material-ui/Table/TableHead'
import TableCell from 'material-ui/Table/TableCell'
import TableBody from 'material-ui/Table/TableBody'
import TableRow from 'material-ui/Table/TableRow'
import FormControl from 'material-ui/Form/FormControl'
import InputLabel from 'material-ui/Input/InputLabel'
import Select from 'material-ui/Select'
import MenuItem from 'material-ui/Menu/MenuItem'

import 'chart.piecelabel.js'
import chartsStyle from 'assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx'


class Agenti extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      meseAnno: moment().format('MMMM YYYY'),
      annoAndamento: moment().format('YYYY'),
      tipoAndamento: "CONTATTI_ASSEGNATI"
    }
  }

  handleChangePeriodo = event => {
    this.setState({ 
      meseAnno: moment(event).format('MMMM YYYY')
    })
  }

  handleChangeAnnoAndamento = event => {
    this.setState({ 
      annoAndamento: moment(event).format('YYYY')
    })
  }

  handleChangeTipoAndamento = event => {
    this.setState({ 
      tipoAndamento: event.target.value
    })
  }

  renderTableAgenti = (mese, anno) => {
    const { classes } = this.props

    return (
      <Query 
        query={statsAgentiTable}
        variables={{ mese: parseInt(mese, 10), anno: parseInt(anno, 10) }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>
  
          return (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeadCell}>Agente</TableCell>
                  <TableCell className={classes.tableHeadCell}>Clienti assegnati</TableCell>
                  <TableCell className={classes.tableHeadCell}>N° telefonate</TableCell>
                  <TableCell className={classes.tableHeadCell}>N° whatsapp</TableCell>
                  <TableCell className={classes.tableHeadCell}>N° email</TableCell>
                  <TableCell className={classes.tableHeadCell}>App. fissati agente</TableCell>
                  <TableCell className={classes.tableHeadCell}>App. confermati segretaria</TableCell>
                  <TableCell className={classes.tableHeadCell}>App. confermati cliente</TableCell>
                  <TableCell className={classes.tableHeadCell}>App. fatti</TableCell>
                  <TableCell className={classes.tableHeadCell}>App. saltati/annullati</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.statsAgentiTable.map(agente => (
                  <TableRow key={agente.idAgente}>
                    <TableCell className={classes.tableCell}><Link to={`/agenti/${agente.idAgente}`}>{agente.nomeAgente}</Link></TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroClientiAssegnati}</TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroTelefonateOut}</TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroWhatsappOut}</TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroEmailOut}</TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroAppuntamentiStatoFissatoAgente}</TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroAppuntamentiStatoConfermatoSegretaria}</TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroAppuntamentiStatoConfermatoCliente}</TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroAppuntamentiStatoFatto}</TableCell>
                    <TableCell className={classes.tableCell}>{agente.numeroAppuntamentiSaltatiAnnullati}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )
        }}
      </Query>
    )
  }

  renderPiesAgenti = (mese, anno) => {
    return (
      <Query 
      query={statsAgentiPieCharts}
      variables={{ mese: parseInt(mese, 10), anno: parseInt(anno, 10) }}
      fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>

          const sortedStats = type => {
            return _orderBy(data.statsAgentiPieCharts[type], ['valore'], ['desc'])
          }

          const values = type => {
            return sortedStats(type).map(stat => stat.valore)
          }

          const hoverColors = type => {
            return sortedStats(type).map(stat => `hsla(${stat.colore}, 0.8)`)
          }
          const colors = type => {
            return sortedStats(type).map(stat => `hsla(${stat.colore}, 1)`)
          }

          const labels = type => {
            const sum = function(a, b) { return a + b }
            return sortedStats(type).map(stat => Math.round(stat.valore / values(type).reduce(sum, 0) * 100) + '% - ' + stat.nome)
          }

          const datasets = type => {
            return pieChartDataset(labels(type), colors(type), colors(type), hoverColors(type), values(type))
          }

          const pieChartOptions = title => {
            return {
              maintainAspectRatio: false,
              layout: {
                padding: {
                  bottom: 0,
                }
              },
              title: {
                display: true,
                text: title,
                fontSize: 20,
                fontStyle: 'normal',
                padding: 20
              },
              legend: {
                display: true,
                position: 'right',
                labels: {
                  boxWidth: 13,
                  padding: 10
                }
              },
              pieceLabel: {
                render: 'percentage',
                fontColor: '#fff',
                position: 'border',
                textShadow: true
              }
            }
          }

          return (
            <div>
              <GridContainer
                justify="space-around"
                alignItems="flex-start"
                direction="row"
              >
                <ItemGrid xs={12} md={8} lg={7} xl={4}>
                  <div className="chart-container" style={{ height: 300, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                    <Pie
                      data={{
                        labels: labels('numeroClientiAssegnati'),
                        datasets: [datasets('numeroClientiAssegnati')]
                      }} 
                      options={pieChartOptions('Clienti assegnati')} 
                    />
                  </div>
                </ItemGrid>

                <ItemGrid xs={12} md={8} lg={6} xl={4}>
                  <div className="chart-container" style={{ height: 300, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                    <Pie
                      data={{
                        labels: labels('numeroTelefonateOut'),
                        datasets: [datasets('numeroTelefonateOut')]
                      }} 
                      options={pieChartOptions('N° telefonate')} 
                    />
                  </div>
                </ItemGrid>

                <ItemGrid xs={12} md={8} lg={6} xl={4}>
                  <div className="chart-container" style={{ height: 300, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                    <Pie
                      data={{
                        labels: labels('numeroWhatsappOut'),
                        datasets: [datasets('numeroWhatsappOut')]
                      }} 
                      options={pieChartOptions('N° whatsapp')} 
                    />
                  </div>
                </ItemGrid>
    
                <ItemGrid xs={12} md={8} lg={6} xl={4}>
                  <div className="chart-container" style={{ height: 300, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                    <Pie
                      data={{
                        labels: labels('numeroEmailOut'),
                        datasets: [datasets('numeroEmailOut')]
                      }} 
                      options={pieChartOptions('N° email')} 
                    />
                  </div>
                </ItemGrid>
              </GridContainer>

              <GridContainer
                justify="space-around"
                alignItems="flex-start"
                direction="row"
              >
                <ItemGrid xs={12} md={8} lg={6} xl={3}>
                  <div className="chart-container" style={{ height: 300, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                    <Pie
                      data={{
                        labels: labels('numeroAppuntamentiStatoFissatoAgente'),
                        datasets: [datasets('numeroAppuntamentiStatoFissatoAgente')]
                      }} 
                      options={pieChartOptions('App. fissati agente')} 
                    />
                  </div>
                </ItemGrid>

                <ItemGrid xs={12} md={8} lg={6} xl={3}>
                  <div className="chart-container" style={{ height: 300, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                    <Pie
                      data={{
                        labels: labels('numeroAppuntamentiStatoConfermatoSegretaria'),
                        datasets: [datasets('numeroAppuntamentiStatoConfermatoSegretaria')]
                      }} 
                      options={pieChartOptions('App. confermati segretaria')} 
                    />
                  </div>
                </ItemGrid>

                <ItemGrid xs={12} md={8} lg={6} xl={3}>
                  <div className="chart-container" style={{ height: 300, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                    <Pie
                      data={{
                        labels: labels('numeroAppuntamentiStatoConfermatoCliente'),
                        datasets: [datasets('numeroAppuntamentiStatoConfermatoCliente')]
                      }} 
                      options={pieChartOptions('App. confermati cliente')} 
                    />
                  </div>
                </ItemGrid>

                <ItemGrid xs={12} md={8} lg={6} xl={3}>
                  <div className="chart-container" style={{ height: 300, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                    <Pie
                      data={{
                        labels: labels('numeroAppuntamentiStatoFatto'),
                        datasets: [datasets('numeroAppuntamentiStatoFatto')]
                      }} 
                      options={pieChartOptions('Appuntamenti fatti')} 
                    />
                  </div>
                </ItemGrid>
              </GridContainer>
            </div>
          )
        }}
      </Query>
    )
  }

  renderGraficoAnnuale = (anno, tipoAndamento) => {
    return (
      <Query 
        query={statsAgentiLineChartAndamentoAnnuale}
        variables={{ anno: parseInt(anno, 10), tipoAndamento }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>

          const chartOptions = {
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            },
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                boxWidth: 13,
                padding: 20
              }
            }
          }

          const datasets = data.statsAgentiLineChartAndamentoAnnuale.map(dataset => {
            return lineChartDataset(dataset.nome, false, `hsla(${dataset.colore}, 1)`, `hsla(${dataset.colore}, 1)`, dataset.valori)
          })

          return (
            <div className="chart-container" style={{ height: 300 }}>
              <Line
                data={{
                  labels: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
                  datasets
                }} 
                options={chartOptions} 
              />
            </div>         
          )
        }}
      </Query>
    )
  }
  
  render() {
    const { classes } = this.props
    const { meseAnno, annoAndamento, tipoAndamento } = this.state

    const mese = moment(meseAnno, 'MMMM YYYY').format('MM')
    const anno = moment(meseAnno, 'MMMM YYYY').format('YYYY')


    return (
      <GridContainer>
        <ItemGrid xs={12}>
          <IconCard
            icon={Group}
            iconColor="blue"
            title="Performance mensile agenti"
            content={
              <div>
                <GridContainer
                  justify="space-around"
                  alignItems="flex-start"
                  direction="row"
                  style={{ padding: '30px 0' }}
                >
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Periodo</InputLabel>
                    <br />
                    <FormControl fullWidth>
                      <Datetime
                        dateFormat="MMMM YYYY"
                        timeFormat={false}
                        value={meseAnno}
                        onChange={this.handleChangePeriodo} 
                      />
                    </FormControl>
                  </ItemGrid>
                  <ItemGrid xs={3}>
                  </ItemGrid>
                </GridContainer>

                {this.renderTableAgenti(mese, anno)}
                {this.renderPiesAgenti(mese, anno)}
              </div>
            }
          />

          <IconCard
            icon={Timeline}
            iconColor="blue"
            title="Andamento annuale"
            content={
              <div>
                <GridContainer
                  justify="space-around"
                  alignItems="flex-start"
                  direction="row"
                  style={{ padding: '30px 0' }}
                >
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Anno</InputLabel>
                    <br />
                    <FormControl fullWidth>
                      <Datetime
                        dateFormat="YYYY"
                        timeFormat={false}
                        value={annoAndamento}
                        onChange={this.handleChangeAnnoAndamento}
                      />
                    </FormControl>
                  </ItemGrid>
                  <ItemGrid xs={3}>
                    <InputLabel className={classes.label}>Dati</InputLabel>
                    <br />
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={tipoAndamento}
                        onChange={this.handleChangeTipoAndamento}
                        inputProps={{
                          name: "simpleSelect",
                          id: "simple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem
                          }}
                        >
                          -- Seleziona --
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="CONTATTI_ASSEGNATI"
                        >
                          Contatti assegnati
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="N_TELEFONATE_OUT"
                        >
                          N° telefonate fatte
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="N_WHATSAPP_OUT"
                        >
                          N° whatsapp inviati
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="N_EMAIL_OUT"
                        >
                          N° email inviate
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="N_APPUNTAMENTI_FISSATI"
                        >
                          Appuntamenti fissati
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="N_APPUNTAMENTI_FATTI"
                        >
                          Appuntamenti fatti
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="N_APPUNTAMENTI_NON_FATTI"
                        >
                          Appuntamenti non fatti
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </ItemGrid>
                </GridContainer>

                {this.renderGraficoAnnuale(annoAndamento, tipoAndamento)}
              </div>
            }
          />
        </ItemGrid>
      </GridContainer>
    )
  }
}

export default withStyles(chartsStyle)(Agenti)



// WEBPACK FOOTER //
// ./src/views/App/Agenti/Agenti.jsx